import { render, staticRenderFns } from "./GameCardStats.vue?vue&type=template&id=35d9a9d0"
import script from "./GameCardStats.vue?vue&type=script&lang=js"
export * from "./GameCardStats.vue?vue&type=script&lang=js"
import style0 from "./GameCardStats.vue?vue&type=style&index=0&id=35d9a9d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports